import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './brand.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

window.addEventListener('error', (event) => {
  if (event.message && (event.message.includes('Loading chunk') || event.message.includes('Unexpected token'))) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && (event.reason.message.includes('Loading chunk') || event.reason.message.includes('Unexpected token'))) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
